import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarrierTypePipe } from './carrier-type.pipe';



@NgModule({
  declarations: [
    CarrierTypePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [CarrierTypePipe]
})
export class CarrierTypeModule { }
